import Gallery from './Gallery/Gallery';

export default Gallery;